import React, { useState } from 'react';
import { Button, Col, Container, Dropdown, DropdownItem, DropdownMenu, DropdownToggle, Nav, NavbarBrand, NavItem, Row } from 'reactstrap';
import GGHLogo from '../../assets/images/logoGGHM.svg';
import userIcon from '../../assets/images/User.svg';
import { useNavigate } from 'react-router-dom';
import { handleUserData } from '../../slices/UserData/reducer';
import { useDispatch } from 'react-redux';

const StaticNavbar = ({ data, lang, userToken, userKey, pathFor, xpLang }) => {
    const history = useNavigate();
    const dispatch = useDispatch();
    const [isProfileDropdown, setIsProfileDropdown] = useState(false);
    const toggleProfileDropdown = () => {
        setIsProfileDropdown(!isProfileDropdown);
    };

    const handleLogout = () => {
        dispatch(handleUserData({}));
        localStorage.clear();
        sessionStorage.clear();
        if (pathFor === 'xp') {
            if (xpLang && xpLang !== '') history(`/authorize/xp/${lang}/${userToken}/${userKey}`);
            else history(`/authorize/xp/${userToken}/${userKey}`);
        } else {
            history(`/authorize/${userToken}`);
        }
    };

    return (
        // <Navbar fixed="top" light expand="md" className="navbar-bg-light">
        <Container fluid className="py-2">
            <Row className="w-100 align-items-center">
                <Col className="d-flex justify-content-between align-items-center">
                    <NavbarBrand className="cursor-pointer">
                        <img
                            // onClick={resetIndex}
                            src={GGHLogo}
                            alt="Logo"
                            className="custom-logo"
                        />
                    </NavbarBrand>
                    <div>
                        <Dropdown
                            isOpen={isProfileDropdown}
                            toggle={toggleProfileDropdown}
                            className="ms-sm-3 header-item topbar-user"
                            id="profileSelect"
                        >
                            <DropdownToggle tag="button" type="button" className="btn">
                                <span className="d-flex align-items-center">
                                    <img
                                        // onClick={resetIndex}
                                        src={userIcon}
                                        alt="user-icon"
                                    />
                                </span>
                            </DropdownToggle>
                            <DropdownMenu className="dropdown-menu-end">
                                <h6 className="dropdown-header">Welcome {data?.memberName}</h6>
                                <DropdownItem onClick={handleLogout}>
                                    <i className="ri-logout-box-r-line text-muted fs-16 align-middle me-1"></i>
                                    <span className="align-middle" data-key="t-logout">
                                        Logout
                                    </span>
                                </DropdownItem>
                            </DropdownMenu>
                        </Dropdown>
                    </div>
                </Col>
            </Row>
        </Container>
        // </Navbar>
    );
};

export default StaticNavbar;
